import dayjs from "dayjs";

export function hasRequiredPropertyValue(value: unknown): boolean {
  if (value === null || value === undefined) {
    return false;
  }

  if (typeof value === "string") {
    return value.trim().length > 0;
  }

  if (Array.isArray(value)) {
    return value.length > 0;
  }

  if (dayjs.isDayjs(value)) {
    return value.isValid();
  }

  return true;
}
